import React from "react";
import { InfoSection, Pricing } from "../../components";
import { homeObjFour, homeObjOne } from "./Data";

const Services = () => {
  return (
    <>
      <Pricing />
      <InfoSection {...homeObjFour} />
      <InfoSection {...homeObjOne} />
    </>
  );
};

export default Services;
